import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { FormControl } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/Edit';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AddMember from "./AddMember";
import * as XLSX from 'xlsx';
import axios from "../../../../api/axios";
import LOGONEW from "../../../../Images/mrpl.png";
import { AuthContext } from "../../../../context/AuthContext";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const URL = './employeeInformation';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
}));

const ViewMember = () => {
    // Define the columns to match the object structure
    const [jsonData, setJsonData] = useState(null);
    const [retiredList, setRetiredList] = useState([]);
    const columns = [
        // { field: 'id', headerName: 'ID', width: 100 },
        { field: 'memberID', headerName: 'Member ID', width: 150 },
        { field: 'Name', headerName: 'Name', width: 200 },
        { field: 'fathersName', headerName: "Father's Name", width: 200 },
        { field: 'adharNo', headerName: 'Aadhar No.', width: 150 },
        { field: 'dob', headerName: 'Date of Birth', width: 150 },
        { field: 'joinDate', headerName: 'Join Date', width: 150 },
        { field: 'mobileNo', headerName: 'Mobile No.', width: 150 },
        { field: 'department', headerName: 'Department', width: 150 },
        { field: 'status', headerName: 'Status', width: 150 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 200,
            renderCell: (params) => (
                <div style={{ display: 'flex', gap: '10px' }}>
                    <EditData selectedRow={params.row} />
                    <DeleteData selectedRow={params.row} />
                </div>
            )
        }
    ];

    const [open, setOpen] = useState(false);
    const [isAddButton, setIsAddButton] = useState(true);
    const [editData, setEditData] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [isLoading, setGridLoading] = useState(true);
    const [refreshData, setRefreshData] = useState(false);
    const [trackno, setTrackno] = useState('');
    const [memberID, setMembetID] = useState('');
    const [type, setType] = useState('');
    const [alertOpen, setAlertopen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const textfieldStyles = {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'lightgray', // Default border color
            },
            '&:hover fieldset': {
                borderColor: 'lightgray', // Remove hover border color
            },
            '&.Mui-focused fieldset': {
                borderColor: 'lightgray', // Remove focus border color
            },
        },
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertopen(false);
    };

    const serviceMethod = async (mainURL, data, handleSuccess, handleException) => {
        try {
            const response = await axios.delete(mainURL, data);
            return handleSuccess(response.data);
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                return handleException(err?.response.data);
            }
        }
    };

    const serviceUpdateMethod = async (mainURL, data, handleSuccess, handleException) => {
        try {
            const response = await axios.post(mainURL, data);
            console.log(response.data.data);
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                return handleException(err?.response.data);
            }
        }
    };

    useEffect(() => {
        loadData();
    }, [refreshData]);

    const loadData = async () => {
        try {
            const response = await axios.get(URL);
            setDataList(response.data.message || []);
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                console.log(err?.response.data);
                setDataList('');
            }
        }
    };

    const EditData = (props) => {
        return (
            <EditIcon style={{ cursor: "pointer" }} onClick={(e) => {
                e.stopPropagation();
                setEditData(props.selectedRow);
                setIsAddButton(false);
                setOpen(true);
            }} />
        );
    };

    const DeleteData = (props) => {
        return (
            <DeleteIcon style={{ cursor: "pointer" }}
                onClick={() => {
                    const data = { id: props.selectedRow.id };
                    const mainURL = URL + '/' + data.id + '/delete';
                    serviceMethod(mainURL, data, handleSuccess, handleException);
                }}
            />
        );
    };

    const handleSuccess = (data) => {
        setSeverity("success");
        setMessage(data.message);
        setRefreshData((oldValue) => !oldValue);
        setAlertopen(true);
        setTimeout(() => {
            setAlertopen(false);
        }, 1000); // Matches autoHideDuration
    };

    const handleException = (data) => {
        setSeverity("error");
        setMessage(data.message);
        setAlertopen(true);
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const convertImageToBase64 = async () => {
        // Make sure the image path is relative to the public folder
        const response = await fetch(`${process.env.PUBLIC_URL}/mrpl.png`);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };

    const generatePdf = async (data) => {

        // Render the PDFPrint component as static HTML
        const LOGO = await toBase64(LOGONEW);


        // Create the PDF document definition using the converted content
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [20, 20, 20, 20],
            content: [
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: 'MRPL-ONGC KARMACHARI SANGHA (R)', border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 18
                                },
                            ],

                        ]
                    }
                },
                // First Table
                {
                    table: {
                        widths: ['25%', '75%'], // Set the width for each column
                        body: [
                            [
                                {
                                    image: LOGO, // Use the 'image' key for the logo
                                    rowSpan: 4,
                                    fit: [75, 75], // Adjust size as needed
                                    border: [false, false, false, false]
                                },
                                {
                                    text: `Affiliated to: MRPL Employee's Union (R.) and Petroleum & Gas Workers Federation of India.`,
                                    border: [false, false, false, false], fontSize: 7
                                }
                            ],
                            ['', { text: `REGD. No. TUA 495/2007`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `Near Cargo Gate, Opp. Oval Outlet, Bajpe Road Katipalla, Mangalore - 575030.`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `PH: 94807 66036      Email:mrplkarmacharisangha495@yahoo.com && moks.mrpl@gmail.com`, border: [false, false, false, false], bold: true, fontSize: 7 }],
                        ]
                    }
                },
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: `MEMBER LIST`, border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 15
                                },
                            ],

                        ]
                    }
                },
                {
                    table: {
                        widths: ['20%', '20%', '20%', '20%', '20%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: "SL NO",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members ID",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Fathers/Husband Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Mobile NO",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                }
                            ],
                            ...dataList.map((item, index) =>
                                [
                                    {
                                        text: parseInt(index + 1),
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.memberID,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.Name,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.fathersName,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.mobileNo,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    }
                                ]
                            )
                        ]
                    }
                }
            ]
        };

        // Generate the PDF and open it in a new tab
        pdfMake.createPdf(docDefinition).open();
    };

    const getMemberList = () => {
        console.log("fromdate", fromDate);
        console.log("todate", toDate);
        generatePdf();
    }


    const importData = async (json) => {
        try {
            const response = await axios.post("./employeeInformation/importEmp", json);
            // setDataList(response.data.data || []);
            console.log("data from server" + response.data.data || []);
            if (response.data.success == 1) {
                setSeverity("success");
                setMessage("Imported Data Successfully");
                setAlertopen(true);
                setRefreshData((oldValue) => !oldValue);

            }

            // setTimeout(() => {
            //     // navigate("/viewMember");
            //     setOpen(false);
            //     setRefreshData((oldValue) => !oldValue);
            // }, 6000); // Matches autoHideDuration
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                console.log(err?.response.data);
            }
        }
    };

    const retiredData = async (event) => {

        if (!type) {
            alert("Please Select the Retired Type");
            return false;
        } else {
            if (type == "Reset") {
                try {
                    const response = await axios.post("./employeeInformation/insertRetirementData", { type: type });
                    // setDataList(response.data.data || []);
                    console.log("data from server" + response.data.success);
                    if (response.data.success == 1) {
                        setSeverity("success");
                        setMessage("Retired Data Fetched Successfully");
                        setAlertopen(true);
                        setRefreshData((oldValue) => !oldValue);

                    }

                    // setTimeout(() => {
                    //     // navigate("/viewMember");
                    //     setOpen(false);
                    //     setRefreshData((oldValue) => !oldValue);
                    // }, 6000); // Matches autoHideDuration
                } catch (err) {
                    if (!err?.response) {
                        console.log("No server response");
                    } else {
                        console.log(err?.response.data);
                    }
                }
            } else {
                if (fromDate === "" || toDate === "") {
                    alert("Both From Date and To Date cannot be empty!");
                    return false;
                }

                if (new Date(toDate) <= new Date(fromDate)) {
                    alert("To Date must be greater than From Date!");
                    return false;
                } else {
                    try {
                        const response = await axios.post("./employeeInformation/insertRetirementData", { type, fromDate, toDate });
                        // setDataList(response.data.data || []);
                        // setRetiredList
                        if (response.data.status === 401) {
                            setRetiredList([]); // Keep as empty array in case of unauthorized response
                        } else {
                            // const responseData = response.data.data;
                            setRetiredList(response.data.message);
                            console.log("dataList", response.data.message);
                            generateRetiredPdf(response.data.message);
                        }

                        // setTimeout(() => {
                        //     // navigate("/viewMember");
                        //     setOpen(false);
                        //     setRefreshData((oldValue) => !oldValue);
                        // }, 6000); // Matches autoHideDuration
                    } catch (err) {
                        if (!err?.response) {
                            console.log("No server response");
                        } else {
                            setSeverity("error");
                            setMessage(err?.response.data.message);
                            setAlertopen(true);
                            setRefreshData((oldValue) => !oldValue);
                            console.log(err?.response.data.message);
                        }
                    }
                }
            }
        }
    };


    const toBase64 = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // To handle cross-origin issues
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = (err) => reject(new Error(`Failed to load image: ${url}`));
        });
    };

    const generateRetiredPdf = async (dataNew) => {

        // Render the PDFPrint component as static HTML
        const LOGO = await toBase64(LOGONEW);


        // Create the PDF document definition using the converted content
        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [20, 20, 20, 20],
            content: [
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: 'MRPL-ONGC KARMACHARI SANGHA (R)', border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 18
                                },
                            ],

                        ]
                    }
                },
                // First Table
                {
                    table: {
                        widths: ['25%', '75%'], // Set the width for each column
                        body: [
                            [
                                {
                                    image: LOGO, // Use the 'image' key for the logo
                                    rowSpan: 4,
                                    fit: [75, 75], // Adjust size as needed
                                    border: [false, false, false, false]
                                },
                                {
                                    text: `Affiliated to: MRPL Employee's Union (R.) and Petroleum & Gas Workers Federation of India.`,
                                    border: [false, false, false, false], fontSize: 7
                                }
                            ],
                            ['', { text: `REGD. No. TUA 495/2007`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `Near Cargo Gate, Opp. Oval Outlet, Bajpe Road Katipalla, Mangalore - 575030.`, border: [false, false, false, false], fontSize: 7 }],
                            ['', { text: `PH: 94807 66036      Email:mrplkarmacharisangha495@yahoo.com && moks.mrpl@gmail.com`, border: [false, false, false, false], bold: true, fontSize: 7 }],
                        ]
                    }
                },
                {
                    table: {
                        widths: ['100%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: `RETIREMENT LIST`, border: [false, false, false, false], bold: true,
                                    alignment: 'center', fontSize: 15
                                },
                            ],

                        ]
                    }
                },
                {
                    table: {
                        widths: ['10%', '15%', '20%', '15%', '20%', '20%'], // Adjust the column widths for this table
                        body: [
                            [
                                {
                                    text: "SL NO",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Retirement Date",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members ID",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Members Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Fathers/Husband Name",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                },
                                {
                                    text: "Mobile NO",
                                    border: [true, true, true, true],
                                    fontSize: 10
                                }
                            ],
                            ...dataNew.map((item, index) =>
                                [
                                    {
                                        text: parseInt(index + 1),
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.retirementDate,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.memberID,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.Name,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.fathersName,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    },
                                    {
                                        text: item.mobileNo,
                                        border: [true, true, true, true],
                                        fontSize: 10
                                    }
                                ]
                            )
                        ]
                    }
                }
            ]
        };

        // Generate the PDF and open it in a new tab
        pdfMake.createPdf(docDefinition).open();
    };

    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const date = new Date(utc_days * 86400 * 1000);
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
    };

    // Mapping function to convert Excel data to desired format
    const mapExcelDataToDesiredFormat = (data) => {
        return data.map(row => ({
            memberID: row['Member ID '],
            Name: row['Name'],
            fathersName: row['Fathers Name'],
            adharNo: row['Adhar No'],
            dob: excelDateToJSDate(row['Date of Birth ']), // Convert Excel date serial to string
            joinDate: excelDateToJSDate(row['Joining date ']), // Convert Excel date serial to string
            mobileNo: String(row['Mobile No']), // Ensure mobileNo is a string
            department: row['Department'] // Assuming this can be a name or ID, you can further map if needed
        }));
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            // Assuming the Excel file has only one sheet
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Convert sheet to JSON
            const json = XLSX.utils.sheet_to_json(worksheet);
            setJsonData(json);
            const formattedData = mapExcelDataToDesiredFormat(json);
            //   console.log('Converted JSON:', json); // Log JSON in console
            importData(formattedData);

        };

        reader.readAsArrayBuffer(file); // Read file as binary array buffer
    };

    const SendMessage = (e) => {
        alert("hello");
    }

    let filteredRows = dataList;
    // Filter by VIN
    if (memberID) {
        filteredRows = filteredRows.filter((row) =>
            row.memberID?.toLowerCase().includes(memberID.toLowerCase())
        );
    }

    return (
        <div style={{ marginTop: '50px', padding: '25px' }}>
            <div className="topContent">
                <Box sx={{ flexGrow: 1, padding: '10px' }}>
                    <Grid container spacing={2}>

                        <Grid item xs={2} />
                        <Grid item xs={2} />
                        <Grid item xs={2} />
                        <Grid item xs={2}>
                            <FormControl fullWidth>
                                <Typography variant="subtitle2"></Typography>
                            </FormControl>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0d2365',
                                    color: 'white',  // Change background color to purple
                                    '&:hover': {
                                        backgroundColor: '#0d2365',  // Darken the color on hover
                                    },
                                    borderRadius: '10px'
                                }}

                                onClick={() => {
                                    getMemberList();
                                }}
                            >
                                Members List
                            </Button>


                        </Grid>
                        <Grid item xs={2}>
                            <FormControl fullWidth>
                                <Typography variant="subtitle2"></Typography>
                            </FormControl>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#0d2365',
                                    color: 'white',  // Change background color to purple
                                    '&:hover': {
                                        backgroundColor: '#0d2365',  // Darken the color on hover
                                    },
                                    borderRadius: '10px'
                                }}

                                onClick={() => {
                                    setIsAddButton(true);
                                    setOpen(true);
                                    setEditData([]);
                                }}
                            >
                                Add Member
                            </Button>


                        </Grid>
                        <Grid item xs={2}>
                            <FormControl fullWidth>
                                <Typography variant="subtitle2"></Typography>
                            </FormControl>
                            <Button
                                component="label"
                                role={undefined}
                                variant="contained"
                                tabIndex={-1}
                                // startIcon={<CloudUploadIcon />}
                                onClick={retiredData}
                                sx={{
                                    backgroundColor: '#0d2365',
                                    color: 'white',  // Change background color to purple
                                    '&:hover': {
                                        backgroundColor: '#0d2365',  // Darken the color on hover
                                    },
                                    borderRadius: '10px'
                                }}

                            >
                                Retired Data

                            </Button>
                            {/* <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} /> */}

                        </Grid>
                    </Grid>



                    <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                        <Grid item xs={2} >
                            <FormControl fullWidth>
                                <Typography variant="subtitle2">From Date</Typography>
                                <TextField
                                    // label="From Date"
                                    variant="outlined"
                                    type="date" // This makes the field accept only dates
                                    id="joinDate"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    sx={{ marginBottom: 2 }}  // Add some spacing below the input
                                    fullWidth  // Make it full width
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={2} >
                            <FormControl fullWidth>
                                <Typography variant="subtitle2">To Date</Typography>
                                <TextField
                                    // label="From Date"
                                    variant="outlined"
                                    type="date" // This makes the field accept only dates
                                    id="joinDate"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    sx={{ marginBottom: 2 }}  // Add some spacing below the input
                                    fullWidth  // Make it full width
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} >
                            <FormControl fullWidth>
                                <Typography variant="subtitle2">Retired Type</Typography>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Select Type</em>
                                    </MenuItem>

                                    {/* Add Retirement and Donation options */}
                                    <MenuItem value="Print">Print</MenuItem>
                                    <MenuItem value="Reset">Reset</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <Typography variant="subtitle2">Search</Typography>
                                <TextField
                                    // label="Search by Member ID"
                                    variant="outlined"
                                    value={memberID}
                                    onChange={(e) => setMembetID(e.target.value)}  // Update search input
                                    sx={{ marginBottom: 2 }}  // Add some spacing below the input
                                    fullWidth  // Make it full width
                                />
                            </FormControl>
                        </Grid>







                    </Grid>
                </Box>
            </div>
            <div className="GridContent">
                <Box sx={{ flexGrow: 1, padding: '0px', height: 400, width: '100%' }}>
                    <DataGrid
                        rows={filteredRows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        experimentalFeatures={{ newEditingApi: true }}
                        components={{
                            Toolbar: () => (
                                <Box
                                    sx={{
                                        padding: 2,
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        borderBottom: '2px solid #3f51b5',
                                    }}
                                >
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'darknavy' }}>
                                        Members
                                    </Typography>
                                </Box>
                            ),
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                color: 'darknavy',
                                fontWeight: 'bold',
                            },
                        }}
                    />
                    <AddMember
                        isAddButton={isAddButton}
                        setOpen={setOpen}
                        open={open}
                        rowData={editData}
                        setRefreshData={setRefreshData}
                        trackno={trackno}
                    />
                    <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity={severity}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </Box>
            </div>
        </div>
    );
};

export default ViewMember;
